import {
    DragonBonesBaseController,
    IDragonBonesControllerConfiguration,
    Inject
} from "@denishussar/html5-game-engine";

export class DBBonusController extends DragonBonesBaseController {
    public $model: any;

    public constructor(@Inject private _options) {
        super("DBBonusController");
    }

    public getConfiguration(): IDragonBonesControllerConfiguration {
        return {
            armatureName: "bonus_fx",
            childControllers: {},
            animations: {
                idle: "idle",
                collect: "collect"
            },
            modelWatch: {
                isCatch: (value: boolean) => {
                    if (value) {
                        this.$animations.get("collect").play(1);
                    }
                }
            }
        };
    }

    public onInitialize(): void {
        this.y = -135;
        this.scaleX = this.scaleY = 0.9;

        this.$animations.get("idle").play(-1);
    }
}
